module.exports = __webpack_public_path__ + "fa-brands-400.4e9e8847bd8eadca8d81.eot";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/Exchange-NewsAdmin-Frontend/src/assets/fonts/webfonts/fa-brands-400.eot
// module id = ../../../../../src/assets/fonts/webfonts/fa-brands-400.eot
// module chunks = styles